import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import loadable from "@loadable/component";
import LoginPage from "./page/Login/LoginPage";
import DevicePage from "./page/Device/DevicePage";
import UserPage from "./page/User/UserPage";
import ResearchPage from "./page/Deviation/DeviationPage";
import ProfilePage from "./page/Profile/ProfilePage";
import MapPage from "./page/MapPage/MapPage";
import { useSetRecoilState } from "recoil";
import { accessTokenAtom } from "./recoil/auth";
import { useCookies } from "react-cookie";
import { userInfoAtom } from "./recoil/user";
import silentRefresh from "./apis/services/silentRefresh";
import { getUser } from "./apis/api/User/getUser";
import { JWT_EXPIRY_TIME } from "./constants";
import TeamPage from "./page/Team/TeamPage";
import TeamMemberPage from "./page/Team/TeamMemberPage";
import MultiLogPage from "./page/LogPage/MultiLogPage";
import GeoMapPage from "./page/MapPage/GeoMapPage";

//LogPage
const LogPages = loadable(() => import("./page/LogPage/LogPage"));

function Router() {
  const setAccessToken = useSetRecoilState(accessTokenAtom);
  const setUserInfo = useSetRecoilState(userInfoAtom);
  const [cookies] = useCookies(["refreshToken"]);
  useEffect(() => {
    if (cookies.refreshToken) {
      silentRefresh(cookies.refreshToken).then((token) => {
        setAccessToken(token);
        getUser(token).then((user) => {
          setUserInfo(user);
        });
      });
      setInterval(async () => {
        silentRefresh(cookies.refreshToken).then((token) => {
          setAccessToken(token);
          getUser(token).then((user) => {
            setUserInfo(user);
          });
        });
      }, JWT_EXPIRY_TIME - 60000);
    } else {
      setAccessToken(null);
    }
  }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={<p>Loading...</p>}>
        {/* 로딩에 장시간 소모될경우 loading가 출력 */}
        <Routes>
          <Route path="/" element={<MapPage />} />
          <Route path="/log" element={<MultiLogPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/device" element={<DevicePage />} />
          <Route path="/user" element={<UserPage />} />
          <Route path="/deviation" element={<ResearchPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/teamMember" element={<TeamMemberPage />} />
          <Route path="/geotest" element={<GeoMapPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default Router;
